<template>
    <div>
        <div class="justify-between items-center flex h-10 pt-0.5" v-if="!preview">
            <h5 class="text-black font-bold text-28">Prospect</h5>
            <button
                class="link-text text-purple-600 text-13 h-4"
                @click="
                    () => {
                        $event.$emit('modal-open', {
                            view: 'ContactCreate',
                            editingModel: contact,
                        })
                    }
                "
            >
                Edit
            </button>
        </div>

        <div class="flex mt-4 items-center pb-4 lg:pb-6" v-if="!preview">
            <component :is="contact.icon()"
                v-if="pageUser?.labels.contact.source"
                class="mr-3 shrink-0"
                :class='{
                    "w-4.5 h-4.5":  contact.icon() != "IconManualProspect"
                }'
            />
            <!-- <IconZapoAdsLogo
                v-if="contact.archived_at == null && contact.origin_id != null && pageUser.labels.contact.source"
                class="mr-3 w-4.5 h-4.5"
            />
            <IconManualProspect
                v-if="contact.origin_id == null && pageUser.labels.contact.source"
                class="mr-3 shrink-0"
            /> -->

            <div class="w-full">
                <div class="flex justify-between">
                    <NuxtLink
                        v-if="titleLink"
                        no-prefetch
                        tag="a"
                        :to="'/prospects/' + contact.id"
                        class="text-17 font-semibold capitalize underline link-text"
                        >{{ contact.fullName() != null ? contact.fullName() : 'New Contact' }}</NuxtLink
                    >

                    <p class="text-17 font-semibold capitalize" v-else>
                        {{ contact.fullName() != null ? contact.fullName() : 'New Contact' }}
                    </p>
                </div>
                <p class="text-13 text-grey-800">{{ contact.archived_at != null ? 'Archived' : 'Active' }} prospect</p>
            </div>
        </div>

        <div
            class="lg:py-6 py-4 border-grey-500"
            v-if="pageUser.labels.contact.address && contact.hasAddress()"
            :class="[!preview ? 'border-t' : '']"
        >
            <div class="flex items-center justify-between">
                <p class="font-semibold text-17">Address</p>

                <button
                    v-if="preview"
                    class="text-purple-600 underline text-13 h-4"
                    @click="
                        () => {
                            $event.$emit('modal-open', {
                                view: 'ContactCreate',
                                editingModel: contact,
                            })
                        }
                    "
                >
                    Edit
                </button>
            </div>

            <div v-if="contact.hasAddress()" class='pt-2'>
                <p class="text-14 leading-[30px]" v-if="contact.address_line_1">{{ contact.address_line_1 }}</p>
                <p class="text-14 leading-[30px]" v-if="contact.address_line_2">{{ contact.address_line_2 }}</p>
                <p class="text-14 leading-[30px]" v-if="contact.town">{{ contact.town }}</p>
                <p class="text-14 leading-[30px]" v-if="contact.postcode">{{ contact.postcode }}</p>
            </div>

            <div class="mt-2 flex items-center cursor-pointer" v-else>
                <IconPlus class="h-4.5 w-4.5 mr-2 stroke-green-500" />
                <p class="text-15 pt-0.5" @click="edit = true">Add address</p>
            </div>
        </div>

        <div
            class="border-t border-grey-500 lg:py-6 py-4"
            v-if="contact != null && (preview || pageUser.labels.contact.email || pageUser.labels.contact.phone_number)"
        >
            <!-- <p class='font-semibold pb-2'>Contact’s details</p> -->

            <div class="justify-between items-center flex pb-2">
                <h5 class="font-semibold text-17">Contact options</h5>
                <button
                    class="text-purple-600 link-text text-13"
                    @click="
                        () => {
                            $event.$emit('modal-open', {
                                view: 'ContactCommunications',
                                editingModel: contact,
                            })
                        }
                    "
                >
                    Edit
                </button>
            </div>

            <div class="mt-1 grid grid-cols-1 gap-1 w-full">
                <button
                    class="pill hover:border-black cursor-pointer"
                    v-if="contact.getPrimaryEmail() != null && (preview || pageUser.labels.contact.email)"
                    @click="
                        () =>
                            $event.$emit('modal-open', {
                                view: 'Email',
                                modelId: contact.id,
                                modelType: 102,
                                options: {
                                    selectedValueId: contact.primary_email,
                                },
                            })
                    "
                >
                    <IconEmail class="h-4 w-4 stroke-red-600" />
                    <p>{{ contact.getPrimaryEmail().toString() }}</p>
                </button>

                <div class="w-fit"
                    v-tippy="user.crmOutOfFunds() ? { placement: 'right', content: $en.crm.funds(user.crmLink()), allowHTML: true, interactive: true, } : null"
                >
                    <button
                        class="pill hover:border-black cursor-pointer stroke-green-600"
                        v-if="contact.getPrimaryNumber() != null && (preview || pageUser.labels.contact.phone_number)"
                        @click="call(contact.getPrimaryNumber().value)"
                        :disabled="user.crmOutOfFunds()"
                    >
                        <IconPhone class="h-4 w-4" />
                        <p>{{ contact.getPrimaryNumber().toString() }}</p>
                    </button>
                </div>

                <div class="w-fit"
                    v-tippy="user.crmOutOfFunds() ? { placement: 'right', content: $en.crm.funds(user.crmLink()), allowHTML: true, interactive: true, } : null"
                >
                    <button
                        class="pill hover:border-black cursor-pointer"
                        :disabled="user.crmOutOfFunds()"
                        @click="
                            () =>
                                $event.$emit('modal-open', {
                                    view: 'SMS',
                                    modelId: contact.id,
                                    modelType: 102,
                                    options: {
                                        selectedValueId: contact.primary_phone,
                                    },
                                })
                        "
                        v-if="contact.getPrimaryNumber() != null"
                    >
                        <IconSms class="h-4 w-4 stroke-grey-900" />
                        <p>Send SMS</p>
                    </button>
                </div>
            </div>

            <Dropdown
                position="relative"
                class="mt-6"
                :allowClickOutSide="false"
                @dropdown="updatePage"
                :loadOpen="pageUser != null && pageUser.page.additional_communications"
                v-if="pageUser != null && hasAdditionalComms"
            >
                <template #button="{ open }">
                    <div class="flex items-center">
                        <p class="text-14 font-semibold">Additional contacts</p>

                        <IconArrowDown class="ml-2 h-5 w-5 stroke-black transition-all" :class="{ 'rotate-180': open }" />
                    </div>
                </template>

                <template #menu>
                    <div class="flex flex-wrap pt-3 gap-1">
                        <template
                            v-for="comm in contact.communications.filter(
                                (c) => c.id != contact.primary_phone && c.id != contact.primary_email,
                            )"
                        >
                            <div class="w-fit"
                                v-tippy="user.crmOutOfFunds() && comm.type == 0 ? { placement: 'right', content: $en.crm.funds(user.crmLink()), allowHTML: true, interactive: true, } : null"
                            >
                                <button class="pill hover:border-black cursor-pointer"
                                    v-if="comm != null && ((comm.type == 0 && pageUser.labels.contact.phone_number) || (comm.type == 1 && pageUser.labels.contact.email))"
                                    :disabled="user.crmOutOfFunds() && comm.type == 0"
                                    @click="() => {
                                        if (comm.type == 1) {
                                            $event.$emit('modal-open', {
                                                view: 'Email',
                                                modelId: contact.id,
                                                modelType: 102,
                                                options: {
                                                    selectedValueId: comm.id,
                                                },
                                            })
                                        } else {
                                            call(comm.value)
                                        }
                                    }"
                                >
                                    <IconPhone class="h-4 w-4 stroke-green-600" v-if="comm.type == 0" />
                                    <IconEmail class="h-4 w-4 stroke-red-600" v-else />
                                    <p>{{ comm.toString() }}</p>
                                </button>
                            </div>
                        </template>
                    </div>
                </template>
            </Dropdown>
        </div>

        <!-- <ContactCreateModal ref='contactCreateModal'
            :yes='yes'
        /> -->

        <Modal ref="contactCommunicationsModal" width="600px" title="Edit contact options" buttonYes="Save changes">
            <Communications modelType="contact" :modelId="contact.id" :communications="contact.communications" @saved="$emit('saved')" />
        </Modal>
    </div>
</template>

<script>
import Communications from '~/components/customer/input/communications.vue'
// import ContactCreateModal from '~/components/customer/modals/contact-create.vue'

export default {
    props: {
        contact: Object,
        pageUser: Object,
        yes: Function,
        preview: { default: false, type: Boolean },
        titleLink: { default: false, type: Boolean },
    },

    data() {
        return {
            edit: false,
            editComms: false,
        }
    },

    methods: {
        updatePage(value) {
            this.$event.$emit('page-set-page', 'additional_communications', value)
        },

        call(number) {
            this.$event.$emit('make-call', {
                number: number,
                id: this.contact.id,
                type: 102,
                name: this.contact.fullName(),
                link: this.contact.view(),
            })

            setTimeout(() => {
                this.$event.$emit('modal-form-completed')
            }, 2000);
        },
    },

    computed: {
        user() {
            return this.$authSanctum.getUser()
        },

        hasAdditionalComms() {
            return (
                this.contact.communications.filter((c) => {
                    return c.id != this.contact.primary_phone && c.id != this.contact.primary_email
                }).length > 0
            )
        },
    },

    components: {
        Communications: Communications,
    },
}
</script>
